var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderCount, staticClass: "cg-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("span", [_vm._v(_vm._s(_vm.clone.description))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "a-popover",
              {
                attrs: {
                  visible: _vm.columnModalVisible,
                  overlayClassName: "no-padding",
                  placement: "bottom",
                  trigger: "click",
                },
                on: { visibleChange: _vm.changeColumnModalVisible },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "content" }, slot: "content" },
                  [
                    _c("AddColumnForm", {
                      attrs: {
                        "on-cancelled": function () {
                          return _vm.changeColumnModalVisible(false)
                        },
                        "on-completed": _vm.addColumnToContacts,
                        "hidden-columns": _vm.getCols().map(function (x) {
                          return x.key
                        }),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      disabled: _vm.clone.contacts.length === 0,
                      content: _vm.$t("wp.addColumnDesc"),
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "plus" } }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("wp.addColumn")) +
                        "\n                "
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "bottom-end" },
                    expression:
                      "{ followCursor: true, placement: 'bottom-end' }",
                  },
                ],
                attrs: {
                  type: "primary",
                  content: _vm.$t("wp.addNewContactDesc"),
                  disabled: _vm.newContactMode,
                },
                on: { click: _vm.openInsertMode },
              },
              [
                _c("a-icon", { attrs: { type: "plus" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wp.addNewContact")) +
                    "\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "bottom-end" },
                    expression:
                      "{ followCursor: true, placement: 'bottom-end' }",
                  },
                ],
                attrs: {
                  type: "primary",
                  content: _vm.$t("wp.importFileDesc"),
                  disabled: _vm.newContactMode,
                },
                on: { click: _vm.selectFile },
              },
              [
                _c("a-icon", { attrs: { type: "import" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wp.importFile")) +
                    "\n            "
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "bottom-end" },
                    expression:
                      "{ followCursor: true, placement: 'bottom-end' }",
                  },
                ],
                attrs: {
                  type: "primary",
                  content: "Save changes",
                  disabled: !_vm.isChanged() || _vm.updating,
                  loading: _vm.updating,
                },
                on: { click: _vm.update },
              },
              [
                _c("a-icon", { attrs: { type: "save" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wp.saveChanges")) +
                    "\n            "
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showRightWayOfTypingNumber
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column justify-content-center align-items-center text-center",
              attrs: { id: "wp-custom-group-number-input-validation" },
            },
            [
              _c(
                "div",
                {
                  on: {
                    mouseover: function ($event) {
                      _vm.validInput = true
                    },
                    mouseleave: function ($event) {
                      _vm.validInput = false
                    },
                  },
                },
                [
                  _c("a-alert", {
                    attrs: {
                      message:
                        "Please make sure that you have typed the number correctly as showed below!",
                      type: "info",
                      "show-icon": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-row justify-content-center align-items-center text-center",
                },
                [
                  _c(
                    "div",
                    { staticClass: "m-2 p-2" },
                    [
                      _c("a-alert", {
                        attrs: {
                          message: "Invalid",
                          description: "Don't start with plus (+) symbol!",
                          type: "error",
                          "show-icon": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("a-alert", {
                        attrs: { type: "error", message: "+905454443322" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "m-2 p-2" },
                    [
                      _c("a-alert", {
                        attrs: {
                          message: "Invalid",
                          description: "Don't forget country code!",
                          type: "error",
                          "show-icon": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("a-alert", {
                        attrs: { type: "error", message: "05454443322" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "m-2 p-2",
                      class: { "valid-number-typing": _vm.validInput },
                    },
                    [
                      _c("a-alert", {
                        attrs: {
                          message: "Valid",
                          description:
                            "This is the single right way to typing number",
                          type: "success",
                          "show-icon": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("a-alert", {
                        attrs: { message: "905454443322", type: "success" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("a-table", {
        key: "table-" + _vm.renderCount,
        attrs: {
          columns: _vm.getCols(),
          "data-source": _vm.getFilteredRows(),
          scroll: { x: 800 },
          size: "small",
          rowKey: "rowId",
          rowClassName: _vm.getRowClassName,
          pagination: _vm.pagination,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "number",
              fn: function (text, record) {
                return _c("div", {}, [
                  record.new
                    ? _c(
                        "div",
                        [
                          _c("a-input", {
                            attrs: { placeholder: _vm.$t("wp.number") },
                            on: {
                              focus: function ($event) {
                                _vm.showRightWayOfTypingNumber = true
                              },
                              blur: function ($event) {
                                _vm.showRightWayOfTypingNumber = false
                              },
                            },
                            model: {
                              value: _vm.singleContact["number"],
                              callback: function ($$v) {
                                _vm.$set(_vm.singleContact, "number", $$v)
                              },
                              expression: "singleContact['number']",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.updatingContact &&
                      _vm.updatingContact.number === record.number
                    ? _c(
                        "span",
                        [
                          _c("a-input", {
                            attrs: { placeholder: _vm.$t("wp.number") },
                            model: {
                              value: _vm.updatingContact.number,
                              callback: function ($$v) {
                                _vm.$set(_vm.updatingContact, "number", $$v)
                              },
                              expression: "updatingContact.number",
                            },
                          }),
                        ],
                        1
                      )
                    : _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(record.number.replace("@c.us", "")) +
                            "\n            "
                        ),
                      ]),
                ])
              },
            },
            _vm._l(
              _vm.getCols().filter(function (x) {
                return x.isCustom
              }),
              function (col) {
                return {
                  key: "renderSlot-" + col.key,
                  fn: function (text, record) {
                    return [
                      record.new
                        ? _c(
                            "div",
                            [
                              _c("a-input", {
                                attrs: { placeholder: col.title },
                                model: {
                                  value: _vm.singleContact[col.key],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.singleContact, col.key, $$v)
                                  },
                                  expression: "singleContact[col.key]",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm.updatingContact &&
                          _vm.updatingContact.number === record.number
                        ? _c(
                            "span",
                            [
                              _c("a-input", {
                                attrs: { placeholder: col.title },
                                model: {
                                  value:
                                    _vm.updatingContact.attributes[col.key],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.updatingContact.attributes,
                                      col.key,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "updatingContact.attributes[col.key]",
                                },
                              }),
                            ],
                            1
                          )
                        : _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$_.isEmpty(
                                    _vm.$_.get(record, col.key, "-")
                                  )
                                    ? "-"
                                    : _vm.$_.get(record, col.key, "-")
                                ) +
                                "\n            "
                            ),
                          ]),
                    ]
                  },
                }
              }
            ),
            {
              key: "action",
              fn: function (text, record) {
                return _c("div", {}, [
                  record.new
                    ? _c(
                        "div",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "danger",
                                ghost: "",
                                size: "small",
                              },
                              on: { click: _vm.closeInsertMode },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("wp.cancel")) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                ghost: "",
                                size: "small",
                              },
                              on: { click: _vm.insertSingleContact },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("wp.save")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c("span", { staticClass: "w-100" }, [
                        !!_vm.updatingContact &&
                        _vm.updatingContact.number === record.number
                          ? _c(
                              "div",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      ghost: "",
                                      size: "small",
                                    },
                                    on: { click: _vm.cancelUpdatingContact },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      ghost: "",
                                      size: "small",
                                    },
                                    on: { click: _vm.saveUpdatingContact },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.$t("wp.save"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "operation-buttons w-100" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-icons mx-2 text-primary operation-button",
                                    on: {
                                      click: function () {
                                        return _vm.onEditContact(record)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        edit\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-icons mx-2 text-danger operation-button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteContact(record)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        delete\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ]),
                ])
              },
            },
            {
              key: "indexSlot",
              fn: function (text, record) {
                return _c("div", {}, [
                  record.new
                    ? _c("div", [
                        _c(
                          "span",
                          { staticClass: "addIcon" },
                          [_c("a-icon", { attrs: { type: "plus" } })],
                          1
                        ),
                      ])
                    : _c("span", [_vm._v(" " + _vm._s(text) + " ")]),
                ])
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.importFromFileMode,
            width: "90vw",
            footer: null,
            title: "",
          },
          on: {
            cancel: function () {
              _vm.importFromFileMode = false
            },
          },
        },
        [
          _c("ImportContactsFromFile", {
            attrs: {
              "on-completed": _vm.importCandidateFromFile,
              "on-cancelled": function () {
                return (_vm.importFromFileMode = false)
              },
              "required-attributes": _vm.getAddedAttributes(),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.saveChangesModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Değişiklikleri Kaydet",
                showFooter: false,
                className: "save-changes-modal",
              },
              on: { cancel: _vm.cancelSaveChanges, ok: _vm.cancelSaveChanges },
            },
            [
              _c("div", { staticClass: "save-changes-modal-content" }, [
                _c("p", [
                  _vm._v(
                    "\n                Eklediğiniz numaralarda Türkiye numaraları için otomatik düzeltme yapılsın mı? Otomatik düzeltme\n                özelliği, eğer numaralar 10 veya 11 haneli ise başına 9 veya 90 ekleyecektir.\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "save-changes-options" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.saveChangesWithAutoFix },
                      },
                      [
                        _vm._v(
                          "\n                    Otomatik Düzeltme Uygulayarak Kaydet\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { ghost: "" },
                        on: { click: _vm.saveChangesWithoutAutoFix },
                      },
                      [_vm._v(" Direkt Kaydet")]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { danger: "" },
                        on: { click: _vm.cancelSaveChanges },
                      },
                      [_vm._v("Vazgeç")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }